module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"eggs\"-in-long-beach-california-7bcbeea48c8e9e76f9d0caff1a8a0304.png";